export default __webpack_public_path__ + "static/media/502900fb-169b-4ede-886c-efacfa78a67b.564dc544.jpg";